"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRequest = void 0;
let xhr;
const makeRequest = (method, endpoint, data, cache, onReceiveData, customRequest, setIsLoading) => {
    let cacheKey;
    if (cache) {
        cacheKey = cache.serializeCacheKey({
            headers: data.headers,
            body: data.json,
            url: endpoint,
            method,
        });
        const cachedData = cache.get(cacheKey);
        if (cachedData) {
            onReceiveData(cachedData);
            return;
        }
    }
    if (customRequest) {
        if (setIsLoading)
            setIsLoading(true);
        customRequest(data.json)
            .then((res) => {
            var _a;
            const data = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.suggestions;
            if (setIsLoading)
                setIsLoading(false);
            if (data) {
                if (!Array.isArray(data)) {
                    cache === null || cache === void 0 ? void 0 : cache.set(cacheKey, [data]);
                    onReceiveData([data]);
                }
                else {
                    onReceiveData(data);
                    cache === null || cache === void 0 ? void 0 : cache.set(cacheKey, data);
                }
            }
            else {
                cache === null || cache === void 0 ? void 0 : cache.set(cacheKey, []);
                onReceiveData([]);
            }
        })
            .catch(() => {
            if (setIsLoading)
                setIsLoading(false);
        });
    }
    else {
        if (xhr)
            xhr.abort();
        xhr = new XMLHttpRequest();
        xhr.open(method, endpoint);
        if (data.headers) {
            Object.entries(data.headers).forEach(([header, headerValue]) => {
                xhr.setRequestHeader(header, headerValue);
            });
        }
        xhr.send(JSON.stringify(data.json));
        xhr.onreadystatechange = () => {
            var _a;
            if (!xhr || xhr.readyState !== 4) {
                return;
            }
            if (xhr.status === 200 && (xhr === null || xhr === void 0 ? void 0 : xhr.response)) {
                const payload = (_a = JSON.parse(xhr.response)) === null || _a === void 0 ? void 0 : _a.suggestions;
                if (payload) {
                    if (!Array.isArray(payload)) {
                        cache === null || cache === void 0 ? void 0 : cache.set(cacheKey, [payload]);
                        onReceiveData([payload]);
                    }
                    else {
                        cache === null || cache === void 0 ? void 0 : cache.set(cacheKey, payload);
                        onReceiveData(payload);
                    }
                }
                else {
                    cache === null || cache === void 0 ? void 0 : cache.set(cacheKey, []);
                    onReceiveData([]);
                }
            }
        };
    }
};
exports.makeRequest = makeRequest;
